module.exports = __webpack_public_path__ + "static/media/kinnection.ece69531.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kinnection.png
// module id = 104
// module chunks = 0